import React, { useEffect, useState } from 'react';
import BaseHome from '../Home/BaseHome';
import { useParams } from 'react-router-dom';
import { getBlogDetails } from '../../api/worldOfEsports.api';
import { url } from '../../config/url';
import ListLoader from '../Common/ListLoader';
import { useLocation } from "react-router-dom";
import { t } from 'i18next';
import ReactPlayer from "react-player";

const OpenPopularVideo = () => {
    const location = useLocation();
    const { id, name, url } = location.state || {}; // Handle undefined state
    
    return (
        <BaseHome isFooter={false} title={t("woe.videos")} MaxFullPageScroll={true}>
            <ReactPlayer
                url={url}
                playing={false}
                controls
                width="100%"
                height="250px"
                config={{
                youtube: {
                    playerVars: {
                    rel: 0,
                    modestbranding: 1,
                    disablekb: 1,
                    fs: 0, // ✅ Disable fullscreen
                    playsinline: 1,
                    },
                },
                }}
            />
        </BaseHome>
    );
};

export default OpenPopularVideo;
